import { render, staticRenderFns } from "./InstitutionTypeOrganizationalStructureType.vue?vue&type=template&id=a9253a7e"
import script from "./InstitutionTypeOrganizationalStructureType.vue?vue&type=script&lang=js"
export * from "./InstitutionTypeOrganizationalStructureType.vue?vue&type=script&lang=js"
import style0 from "./InstitutionTypeOrganizationalStructureType.vue?vue&type=style&index=0&id=a9253a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports